import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Upload icon for representing file upload actions
 */
export const UploadIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="17 8 12 3 7 8"></polyline>
      <line x1="12" y1="3" x2="12" y2="15"></line>
    </Icon>
  );
};

export default UploadIcon;
